/* PACKRIFT-EMAIL-CAPTURE-2026-09-07-R02
 * Shared email-capture client for packrift.com (Packrift Price Watch signup).
 * - Any <form data-pk-capture data-pk-source="..."> posts to the subscribe endpoint (Omnisend).
 * - [data-pk-inline] slots are filled client-side with the inline signup block (keeps promo copy out of crawled HTML).
 * - #pk-popup (snippets/packrift-capture-popup.liquid) opens as:
 *     desktop  -> corner flyout after a short dwell (10s, 6s on a second pageview); exit intent opens the centered modal
 *     mobile   -> a slim teaser bar after 12s and 40% scroll; tapping it opens the bottom sheet (no first-view interstitial)
 *   Caps: once per session, 14 days after a dismiss, never after signup, never on utm_medium=email, never on product
 *   pages unless data-pk-products="true". URL overrides: ?pk_popup=1 forces it, ?pk_popup=0 suppresses it.
 * - Fires GA4 `sign_up` (method=email) plus popup_view / popup_dismiss, and mirrors to dataLayer. No third-party scripts.
 */
(function () {
  'use strict';
  if (window.__pkCapture) return;
  window.__pkCapture = true;

  var CFG = window.__PK_CAPTURE__ || {};
  var ENDPOINT = CFG.endpoint || 'https://mcp.packrift.com/subscribe';
  var LS_SUB = 'pk_sub';
  var LS_DISMISS = 'pk_popup_dismissed_at';
  var SS_SHOWN = 'pk_popup_shown';
  var SS_PV = 'pk_pv';
  var DISMISS_DAYS = 14;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function ls(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function ss(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function qs(name) { try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function track(name, params) {
    // Analytics permission is separate from submitting the requested signup.
    try {
      if (!window.Shopify || window.Shopify.designMode || !window.Shopify.customerPrivacy ||
          window.Shopify.customerPrivacy.analyticsProcessingAllowed() !== true ||
          qs('pk_qa') === '1' || qs('pf_lab_qa') === '1' || qs('pbq_qa') === '1' || qs('test_event') === 'true') return;
    } catch (e) { return; }
    params = params || {};
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); } catch (e) {}
  }

  /* ---------- inline blocks (client-rendered) ---------- */
  function formHtml(source, button, success) {
    var id = 'pk-cap-' + source.replace(/[^a-z0-9]+/gi, '-') + '-email';
    return '<form class="pk-capture__form" data-pk-capture data-pk-source="' + esc(source) + '" data-pk-success="' + esc(success) + '" novalidate>' +
      '<label class="visually-hidden" for="' + id + '">Work email</label>' +
      '<input id="' + id + '" type="email" name="email" placeholder="Work email" autocomplete="email" required>' +
      '<button type="submit" class="pk-capture__btn">' + esc(button) + '</button>' +
      '<div class="pk-capture__hp" aria-hidden="true"><label>Website<input type="text" name="website" tabindex="-1" autocomplete="off"></label></div>' +
      '</form><p class="pk-capture__msg" data-pk-msg hidden></p><p class="pk-capture__fine" data-pk-fine>One email a month. Unsubscribe any time.</p>';
  }

  function renderInline() {
    var slots = document.querySelectorAll('[data-pk-inline]');
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i];
      if (s.getAttribute('data-pk-rendered')) continue;
      s.setAttribute('data-pk-rendered', '1');
      var source = s.getAttribute('data-pk-source') || 'inline';
      var compact = s.getAttribute('data-pk-compact') === 'true';
      var html = '<aside class="pk-capture' + (compact ? ' pk-capture--compact' : '') + '" data-pk-capture-block="' + esc(source) + '">' +
        '<div class="pk-capture__text"><span class="pk-capture__kicker">' + esc(s.getAttribute('data-pk-kicker') || 'Packrift Price Watch') + '</span>' +
        '<p class="pk-capture__heading">' + esc(s.getAttribute('data-pk-heading') || '') + '</p>' +
        '<p class="pk-capture__sub">' + esc(s.getAttribute('data-pk-sub') || '') + '</p></div>' +
        '<div class="pk-capture__side">' + formHtml(source, s.getAttribute('data-pk-button') || 'Send me the report', s.getAttribute('data-pk-success') || 'You are on the list. The current edition is on its way to your inbox.') + '</div></aside>';
      if (ls(LS_SUB)) {
        html = '<aside class="pk-capture pk-capture--compact" data-pk-capture-block="' + esc(source) + '"><div class="pk-capture__text"><span class="pk-capture__kicker">Packrift Price Watch</span><p class="pk-capture__sub">You are on the list. The next edition arrives at the start of the month.</p></div></aside>';
      }
      s.innerHTML = html;
    }
  }

  /* ---------- submit ---------- */
  function setMsg(form, kind, text) {
    var box = form.parentNode ? form.parentNode.querySelector('[data-pk-msg]') : null;
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
    box.setAttribute('data-kind', kind || '');
  }

  function collectProps(form) {
    var props = {};
    var nodes = form.querySelectorAll('[data-pk-prop]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var key = n.getAttribute('data-pk-prop');
      var val = n.value != null ? n.value : n.textContent;
      if (key && val) props[key] = String(val).trim().slice(0, 240);
    }
    return props;
  }

  function submit(form) {
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var email = input ? input.value.trim() : '';
    var source = form.getAttribute('data-pk-source') || 'site';
    if (!EMAIL_RE.test(email)) { setMsg(form, 'error', 'Enter a valid email address.'); if (input) input.focus(); return; }
    var hp = form.querySelector('input[name="website"]');
    var payload = {
      email: email,
      source: source,
      first_name: (form.querySelector('input[name="first_name"]') || {}).value || '',
      tags: (form.getAttribute('data-pk-tags') || '').split(',').filter(Boolean),
      props: collectProps(form),
      page: window.location.pathname,
      website: hp ? hp.value : ''
    };
    if (btn) { btn.disabled = true; btn.setAttribute('data-label', btn.textContent); btn.textContent = 'Sending'; }
    setMsg(form, '', '');
    fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j || {} }; }); })
      .then(function (res) {
        if (res.ok && res.body && res.body.ok) {
          lsSet(LS_SUB, '1');
          success(form, res.body.status);
          if (res.body.status === 'subscribed') track('sign_up', { method: 'email', capture_source: source, page_path: window.location.pathname });
          if (source === 'popup') setTimeout(function () { closePopup(true); }, 2800);
          return;
        }
        var why = res.status === 429 ? 'Too many tries from this connection. Try again in an hour.' : 'That did not go through. Try again in a moment.';
        setMsg(form, 'error', why);
        if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label'); }
      })
      .catch(function () {
        setMsg(form, 'error', 'That did not go through. Try again in a moment.');
        if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label'); }
      });
  }

  function success(form, status) {
    var text = form.getAttribute('data-pk-success') || 'You are on the list. The current edition is on its way to your inbox.';
    if (status === 'already_subscribed') text = 'You are already on the list. The next edition arrives at the start of the month.';
    var done = document.createElement('p');
    done.className = 'pk-capture__done';
    done.setAttribute('role', 'status');
    done.textContent = text;
    form.parentNode.insertBefore(done, form);
    form.hidden = true;
    var fine = form.parentNode.querySelector('[data-pk-fine]');
    if (fine) fine.hidden = true;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-pk-capture]') : null;
    if (!form) return;
    e.preventDefault();
    submit(form);
  });

  /* ---------- popup / flyout / sheet / teaser ---------- */
  var popup = null, teaser = null, opened = false, armed = false, timers = [];

  function popupAllowed() {
    popup = document.getElementById('pk-popup');
    teaser = document.getElementById('pk-teaser');
    if (!popup) return false;
    var force = qs('pk_popup');
    if (force === '0') return false;
    if (force === '1' || force === 'all') return true;
    if (ls(LS_SUB)) return false;
    if (ss(SS_SHOWN)) return false;
    var d = Number(ls(LS_DISMISS) || 0);
    if (d && Date.now() - d < DISMISS_DAYS * 864e5) return false;
    var medium = (qs('utm_medium') || '').toLowerCase();
    if (medium === 'email') return false;
    if (popup.getAttribute('data-pk-products') !== 'true' && popup.getAttribute('data-pk-template') === 'product') return false;
    return true;
  }

  function isDesktop() { return window.matchMedia('(min-width: 768px)').matches && window.matchMedia('(hover: hover)').matches; }

  function openPopup(mode, reason) {
    if (opened || !popup) return;
    opened = true;
    clearTimers();
    ssSet(SS_SHOWN, '1');
    hideTeaser();
    popup.setAttribute('data-mode', mode);
    popup.hidden = false;
    if (mode !== 'flyout') document.documentElement.classList.add('pk-popup-open');
    setTimeout(function () { popup.classList.add('is-open'); }, 30);
    var input = popup.querySelector('input[type="email"]');
    if (mode === 'modal' && input) setTimeout(function () { input.focus(); }, 250);
    track('popup_view', { popup_id: 'price-watch', popup_mode: mode, trigger: reason, page_path: window.location.pathname });
  }

  function closePopup(afterSignup) {
    if (!popup || popup.hidden) return;
    popup.classList.remove('is-open');
    document.documentElement.classList.remove('pk-popup-open');
    setTimeout(function () { popup.hidden = true; }, 220);
    if (!afterSignup) {
      lsSet(LS_DISMISS, String(Date.now()));
      track('popup_dismiss', { popup_id: 'price-watch', popup_mode: popup.getAttribute('data-mode') || '', page_path: window.location.pathname });
    }
  }
  window.pkClosePopup = closePopup;

  function showTeaser() {
    if (!teaser || opened || !teaser.hidden) return;
    teaser.hidden = false;
    ssSet(SS_SHOWN, '1');
    setTimeout(function () { teaser.classList.add('is-open'); }, 30);
    track('popup_view', { popup_id: 'price-watch', popup_mode: 'teaser', trigger: 'mobile_dwell_scroll', page_path: window.location.pathname });
  }
  function hideTeaser() {
    if (!teaser || teaser.hidden) return;
    teaser.classList.remove('is-open');
    setTimeout(function () { teaser.hidden = true; }, 200);
  }

  function clearTimers() { timers.forEach(clearTimeout); timers = []; }

  function scrolledPct() {
    var h = document.documentElement;
    var total = Math.max(1, (h.scrollHeight || 1) - window.innerHeight);
    return Math.min(100, Math.round(((window.pageYOffset || h.scrollTop || 0) / total) * 100));
  }

  function armPopup() {
    renderInline();
    var pv = Number(ss(SS_PV) || 0) + 1;
    ssSet(SS_PV, String(pv));
    if (armed || !popupAllowed()) return;
    armed = true;
    var start = Date.now();
    var desktop = isDesktop();
    var desktopDelay = Number(popup.getAttribute(pv >= 2 ? 'data-pk-desktop-delay-repeat' : 'data-pk-desktop-delay') || (pv >= 2 ? 6 : 10)) * 1000;
    var exitMin = Number(popup.getAttribute('data-pk-exit-min') || 6) * 1000;
    var mobileDelay = Number(popup.getAttribute('data-pk-mobile-delay') || 12) * 1000;
    var mobileScroll = Number(popup.getAttribute('data-pk-mobile-scroll') || 40);

    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-pk-close]') || (e.target === popup && popup.getAttribute('data-mode') !== 'flyout')) closePopup(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePopup(false); } });
    if (teaser) {
      teaser.addEventListener('click', function (e) {
        if (e.target.closest('[data-pk-teaser-close]')) { hideTeaser(); lsSet(LS_DISMISS, String(Date.now())); track('popup_dismiss', { popup_id: 'price-watch', popup_mode: 'teaser', page_path: window.location.pathname }); return; }
        if (e.target.closest('[data-pk-teaser-open]')) { opened = false; openPopup('sheet', 'teaser_tap'); }
      });
    }

    var force = qs('pk_popup');
    if (force === '1' || force === 'all') { setTimeout(function () { openPopup(desktop ? 'modal' : 'sheet', 'forced'); }, 400); return; }

    if (desktop) {
      document.addEventListener('mouseout', function (e) {
        if (opened) return;
        if (e.relatedTarget || e.toElement) return;
        if (e.clientY > 0) return;
        if (Date.now() - start < exitMin) return;
        openPopup('modal', 'exit_intent');
      });
      timers.push(setTimeout(function () { openPopup('flyout', pv >= 2 ? 'dwell_repeat_view' : 'dwell'); }, desktopDelay));
    } else {
      var check = function () {
        if (opened) return;
        if (Date.now() - start >= mobileDelay && scrolledPct() >= mobileScroll) { window.removeEventListener('scroll', check); showTeaser(); }
      };
      window.addEventListener('scroll', check, { passive: true });
      timers.push(setTimeout(function () { if (!opened && scrolledPct() >= mobileScroll) showTeaser(); }, mobileDelay + 200));
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armPopup);
  else armPopup();
})();
